import { useContext } from "react";
import {
  ILanguageContext,
  LanguageContext,
} from "../providers/LanguageProvider";

export const useLanguages = (): ILanguageContext =>
  useContext<ILanguageContext>(LanguageContext);
